<template>
  <div class="container">
    <h2 class="mb-5">Manage countries</h2>

    <form method="post" name="test" @submit.prevent="onSubmit" :data-vv-scope="formScope">
      <div class="row">
        <div class="col-md-7">
          <base-text name="code" v-validate="'required'" label="Code"
                     v-model="country.code" :readonly="this.oldCode"
                     :err="errors.collect('code', formScope)"></base-text>
          <base-text name="name" v-validate="'required'" label="Name"
                     v-model="country.name"
                     :err="errors.collect('name', formScope)"></base-text>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-6 text-left">
          <base-button radius="bl" component-class="blue" @click.native="$router.go(-1)">
            <i class="fas fa-arrow-left mr-3"></i> Previous
          </base-button>
        </div>
        <div class="col-6 text-right">
          <base-button radius="br" component-class="green filled" type="submit">
            Save <i class="fas fa-arrow-right ml-3"></i>
          </base-button>
        </div>
      </div>

    </form>

  </div>
</template>

<script>

  import BaseButton from '../../../../components/inputs/button/BaseButton';
  import BaseText from '../../../../components/inputs/text/BaseText';

  export default {
    name: 'CountryList',
    mounted () {
      if (typeof this.country.code !== 'undefined') {
        this.oldCode = this.country.code;
      }
    },
    methods: {
      onSubmit() {
        this.$validator.validateAll(this.formScope).then(() => {
          this.$store.dispatch('countries/save', { country: this.country, oldCode: this.oldCode }).then(() => {
            this.$snotify.success('Country saved.');
            this.$router.push({name: 'user.manage-countries'});
          });
        });
      }
    },
    watch: {
    },
    data() {
      return {
        formScope: 'showCountry',
        oldCode: null
      };
    },
    computed: {
      country: {
        get () {
          return this.$store.getters['countries/current'];
        },
        set () {
          this.$store.getters['countries/current'];
        }
      },
      countries: {
        get () {
          return this.$store.getters['countries/countries'];
        },
        set (value) {
          this.$store.commit('countries/countries', value);
        }
      }
    },
    components: {
      BaseButton, BaseText
    }
  };

</script>
